export const InterfaceToSearchParams = (params: any) => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key) => searchParams.append(key, params[key] ?? undefined));

  return searchParams;
};
